<template>
  <div class="container">
    <div class="row direction-column">
      <AmusnetJackpot v-if="!isMobile"></AmusnetJackpot>
        <div class="banners" v-if="!isMobile">
          <div class="row">
            <div class="col">
              <router-link to="/sportsbook">
                <img src="@/assets/images/common/buttons/1.png" width="100%">
              </router-link>
            </div>
            <div class="col">
              <router-link to="/live">
                <img src="@/assets/images/common/buttons/2.png" width="100%">
              </router-link>
            </div>
            <div class="col">
              <router-link to="/casino">
                <img src="@/assets/images/common/buttons/3.png" width="100%">
              </router-link>
            </div>
            <div class="col">
              <router-link to="/slot">
                <img src="@/assets/images/common/buttons/4.png" width="100%">
              </router-link>
            </div>
            <div class="col" v-if="!isMobile">
              <router-link to="/aviator">
                <img src="@/assets/images/common/buttons/5.png" width="100%">
              </router-link>
            </div>
          </div>
        </div>
        <div class="mobile-banners" v-if="isMobile">
            <div class="col col-xs-4">
              <router-link to="/sportsbook">
                <img src="@/assets/images/common/icons/1.png" width="100%">
              </router-link>
            </div>
            <div class="col col-xs-4">
              <router-link to="/live">
                <img src="@/assets/images/common/icons/2.png" width="100%">
              </router-link>
            </div>
            <div class="col col-xs-4">
              <router-link to="/slot">
                <img src="@/assets/images/common/icons/3.png" width="100%">
              </router-link>
            </div>
            <div class="col col-xs-4">
              <router-link to="/casino">
                <img src="@/assets/images/common/icons/4.png" width="100%">
              </router-link>
            </div>
            <div class="col col-xs-4">
              <router-link to="/virtual">
                <img src="@/assets/images/common/icons/5.png" width="100%">
              </router-link>
            </div>
            <div class="col col-xs-4">
              <router-link to="/user/withdraw">
                <img src="@/assets/images/common/icons/6.png" width="100%">
              </router-link>
            </div>
            <div class="col col-xs-4">
              <router-link to="/user/deposit">
                <img src="@/assets/images/common/icons/7.png" width="100%">
              </router-link>
            </div>
            <div class="col col-xs-4">
              <router-link to="/promotions">
                <img src="@/assets/images/common/icons/8.png" width="100%">
              </router-link>
            </div>
            <div class="col col-xs-4">
              <router-link to="/aviator">
                <img src="@/assets/images/common/icons/9.png" width="100%">
              </router-link>
            </div>
        </div>
    <AmusnetJackpot v-if="isMobile"></AmusnetJackpot>
      <div class="row row-wrap" style="margin: 0px;" >
        <div class="col col-6 col-xs-12">
          <div class="casino-card">
            <div class="top">
              <h1>Slot Oyunları</h1>
              <router-link to="/slot">Daha Fazla</router-link>
            </div>
            <div class="row row-wrap">
                <div class="col col-3 item" v-for="item in slotGames">
                    <router-link :to="'/' + item.url">
                      <img width="100%" :src="$store.state.main.cdn_url + item.image"/>
                    </router-link>
                </div>
            </div>
          </div>
        </div>
        <div class="col col-6 col-xs-12">
          <div class="casino-card">
            <div class="top">
              <h1>Canlı Casinolar</h1>
              <router-link to="/casino">Daha Fazla</router-link>
            </div>
            <div class="row row-wrap">
                <div class="col col-3 item" v-for="item in casinoGames">
                    <router-link :to="'/' + item.url">
                      <img width="100%" :src="$store.state.main.cdn_url + item.image"/>
                    </router-link>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { ENV_CURRENT_DOMAIN, ENV_CDN_URL } from '../../plugins/replaces'
  import Jackpot from '../Common/Jackpot'
  import Game from '../Casino/Game'
  import AmusnetJackpot from '../../components/Slot/AmusnetJackpot';
  import UserLogin from '../../views/Auth/Login'
  export default {
    components:{
      Game,
      UserLogin,
      AmusnetJackpot,
      Jackpot
    },
    data() {
      return {
        eventSlider:[],
        partners:[],
        lastWinners:[],
        loginModal: false,
        isLoading: false,
        swiperOption: {
					lazy: true,
					speed: 1500,
          slidesPerView: 3,
          autoplay: {
            delay: 2000,
					},
          // effect: 'fade',
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        },
        swiperOptionWinners: {
					lazy: true,
					speed: 1500,
          slidesPerView: 4,
          autoplay: {
            delay: 2000,
					},
          // effect: 'fade',
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        },
        casinoGames:[
        ],
        slotGames:[
        ]
      }
    },
    created(){
      this.fetchData();
    },
    methods:{
      fetchData: function() {
          if(this.isMobile){
            this.swiperOption.slidesPerView = 1
            this.swiperOptionWinners.slidesPerView = 2;
          }
          this.isLoading = true,
          this.$store.dispatch('getBanner', ['home', 'both', 'bottom'])
          .then(response =>{
            this.eventSlider = _.sortBy(response.data, ['sort'])
            this.isLoading = false;
          });
          this.$store.dispatch('getBanner', ['home', 'both', 'single'])
          .then(response =>{
            this.partners = _.sortBy(response.data, ['sort'])
            this.isLoading = false;
          });
          this.$store.dispatch('getBanner', ['home', 'both', 'left'])
          .then(response =>{
            this.slotGames = _.sortBy(response.data, ['sort'])
            this.isLoading = false;
          });
          this.$store.dispatch('getBanner', ['home', 'both', 'right'])
          .then(response =>{
            this.casinoGames = _.sortBy(response.data, ['sort'])
            this.isLoading = false;
          });
      },
      open(provider, id, route){
        let routeData = this.$router.resolve({ name: route, params: { provider: provider, category : 'all' }, query: { game_id: id, mobile: this.isMobile }});
        if(!this.$auth()){
          this.loginModal = true
          return false;
        }else{
          window.location.href = routeData.href;
        }
      },
    },
    computed:{
      egt_show(){
        if(this.locale == 'TR' && this.user && this.user.balance > 0){
          return true
        }else{
          return false
        }
      },
      client_id(){
        return process.env.VUE_APP_CLIENT_ID
      },
      user(){
        return this.$user();
      },
      cdn_url(){
        return this.$store.getters['getCdnUrl'];
      },
      current_domain(){
        return ENV_CURRENT_DOMAIN;
      },
      locale(){
          return this.$store.getters.getLocale;
      },
      specialTemplate(){
          return this.$store.getters.getSpecialTemplate;
      }
    },
  }
</script>